export const isoFormatDate = (date) =>
  date ? new Date(date).toISOString().split("T")[0] : "-";

export const localDatetime = (timestamp) =>
  new Date(timestamp).toLocaleString();
